/**
 * Labstep
 *
 * @module containers/ResendVerificationEmail
 * @desc Resend email confirmation container
 */

import { resendConfirmationEmail } from 'labstep-web/state/actions/user';
import { selectResendConfirmationEmailStatus } from 'labstep-web/state/selectors/user';
import { connect } from 'react-redux';

export const ConfirmEmail = ({
  status,
  resendVerificationEmail,
  children,
}) => {
  const props = {
    status,
    resendVerificationEmail,
  };
  return children(props);
};

const mapStateToProps = (state) => ({
  status: selectResendConfirmationEmailStatus(state),
});

const mapDispatchToProps = (dispatch) => ({
  resendVerificationEmail() {
    dispatch(resendConfirmationEmail());
  },
});

export const ResendVerificationEmailContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfirmEmail);
